import styled from 'styled-components';

const InformativeSliderStyle = styled.div`
	--isContPaddingV: var(--sp18x);
	--isInfoMarginTop: var(--sp10x);
	--isInfoTitleMarginV: var(--sp6x);
	--isBigImageWidth: 90.615%;
	--isBigImageMarginRight: 7%;
	--isSmallImageWidth: 31.63%;
	--isSmallImageRightPosition: var(--sp20x);
	--isPaginationRightPosition: var(--sp5x);
	--isPaginationSize: var(--sp1x);
	--isPaginationTranslate: 50%;
	--isArrowMargin: var(--sp7x);

	--sizeTextLong: var(--sp20x);

	position: relative;
	padding-top: var(--isContPaddingV);
	padding-bottom: var(--isContPaddingV);
	overflow: hidden;

	.is-container {
		.row {
			position: relative;

			.is-info-container {
				display: flex;
				padding-right: var(--sizeTextLong);

				.is-info-inner-container {
					position: relative;
					width: 100%;
					margin-top: var(--isInfoMarginTop);
					flex: 1;
					overflow: hidden;

					.is-info {
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						opacity: 0;
						transition: var(--trTime);
						pointer-events: none;

						&.active {
							opacity: 1;
							transition: var(--trTime) var(--trTime);
							pointer-events: all;
						}

						.is-info-title {
							margin: var(--isInfoTitleMarginV) 0;
						}

						.is-info-desc {
							margin-bottom: var(--isInfoTitleMarginV);
						}
					}
				}
			}

			.is-right-container {
				display: flex;
				justify-content: flex-end;

				.is-big-image-container {
					position: relative;
					width: var(--isBigImageWidth);
					margin-right: var(--isBigImageMarginRight);
				}

				.is-small-image-container {
					position: absolute;
					right: calc(-1 * var(--isSmallImageRightPosition));
					bottom: 0;
					width: var(--isSmallImageWidth);
					transform: translateX(100%);
				}

				.is-big-image-inner,
				.is-small-image-inner {
					position: relative;
					width: 100%;
					padding-top: 100%;
					border-radius: var(--sp2x);
					overflow: hidden;
				}

				.is-big-image,
				.is-small-image {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;

					&.prev-slide {
						clip-path: inset(0 100% 0 0);
						opacity: 1;
						overflow: hidden;
						z-index: 2;
					}

					&.next-slide {
						clip-path: inset(0 0 0 100%);
						opacity: 1;
						overflow: hidden;
						z-index: 2;
					}
				}

				.imageCont {
					--imagePaddingTop: 100%;
				}
			}

			.action-buttons {
				position: absolute;
				top: 100%;
				left: 0;

				> [class^='giz-'] {
					display: inline-block;
					cursor: pointer;

					&.arrow-left {
						transform: rotate(180deg);
						margin-right: var(--isArrowMargin);
					}
				}
			}
		}
	}

	.pagination-container {
		display: flex;
		flex-direction: column;
		position: absolute;
		bottom: 50%;
		right: var(--isPaginationRightPosition);
		transform: translateY(var(--isPaginationTranslate));

		.pagination-item {
			display: inline-block;
			width: var(--isPaginationSize);
			height: var(--isPaginationSize);
			background: var(--primaryColor3);
			border-radius: calc(var(--isPaginationSize) / 2);
			transition: var(--trTime);
			cursor: pointer;

			&.active {
				height: calc(2.5 * var(--isPaginationSize));
				cursor: none;
			}

			&:not(:last-child) {
				margin-bottom: var(--isPaginationSize);
			}

			&.bg-Malibu,
			&.bg-YellowTan,
			&.bg-White {
				background: var(--bgBlackPearl);
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--isContPaddingV: var(--sp15x);
		--isInfoMarginTop: var(--sp7x);
		--isInfoTitleMarginV: var(--sp4x);
		--isSmallImageRightPosition: var(--sp15x);
		--isPaginationRightPosition: var(--sp4x);
		--isArrowMargin: var(--sp5x);
		--sizeTextLong: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--isContPaddingV: var(--sp13x);
		--isInfoMarginTop: var(--sp2x);
		--isInfoTitleMarginV: var(--sp3x);
		--isSmallImageRightPosition: var(--sp10x);
		--isPaginationRightPosition: var(--sp3x);
		--isArrowMargin: var(--sp4x);
		--sizeTextLong: var(--sp10x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--isContPaddingV: var(--sp12x);
		--isInfoMarginTop: 0;
		--isInfoTitleMarginV: var(--sp2x);
		--isSmallImageRightPosition: var(--sp10x);
		--isPaginationRightPosition: var(--sp3x);
		--isArrowMargin: var(--sp4x);
		--sizeTextLong: var(--sp7x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--isContPaddingV: var(--sp12x);
		--isInfoMarginTop: 0;
		--isInfoTitleMarginV: var(--sp2x);
		--isBigImageMarginRight: 0;
		--isBigImageWidth: 90%;
		--isSmallImageRightPosition: var(--sp8x);
		--isPaginationRightPosition: var(--sp3x);
		--isPaginationTranslate: 20%;
		--isArrowMargin: var(--sp4x);
		--sizeTextLong: 0px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--isContPaddingV: var(--sp10x);
		--isInfoMarginTop: 0;
		--isInfoTitleMarginV: var(--sp2x);
		--isBigImageMarginRight: 0;
		--isBigImageWidth: 90%;
		--isSmallImageRightPosition: var(--sp4x);
		--isPaginationRightPosition: var(--sp2x);
		--isPaginationTranslate: 20%;
		--isArrowMargin: var(--sp3x);
		--sizeTextLong: 0px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--isContPaddingV: var(--sp11x);
		--isInfoMarginTop: 0;
		--isInfoTitleMarginV: var(--sp4x);
		--isBigImageMarginRight: 20%;
		--isBigImageWidth: 75%;
		--isSmallImageWidth: 38%;
		--isSmallImageRightPosition: var(--sp4x);
		--isPaginationRightPosition: var(--sp2x);
		--isPaginationTranslate: 100%;
		--isArrowMargin: var(--sp3x);
		--sizeTextLong: 0px;

		.is-container .row {
			flex-direction: column;

			.is-info-container .is-info-inner-container {
				height: ${(props) => `${props.infoItemHeight}px`};
			}

			.is-right-container {
				align-self: flex-end;
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--isContPaddingV: var(--sp5x);
		--isInfoMarginTop: 0;
		--isInfoTitleMarginV: var(--sp4x);
		--isBigImageMarginRight: 0;
		--isBigImageWidth: 80%;
		--isSmallImageRightPosition: var(--sp4x);
		--isPaginationRightPosition: var(--sp1x);
		--isPaginationTranslate: 90%;
		--isArrowMargin: var(--sp3x);
		--sizeTextLong: 0px;

		.is-container .row {
			flex-direction: column;

			.is-info-container .is-info-inner-container {
				height: ${(props) => `${props.infoItemHeight}px`};
			}

			.is-right-container {
				align-self: flex-end;
				justify-content: flex-start;
			}

			.action-buttons {
				position: relative;
				top: unset;
				left: unset;
				margin-top: var(--sp4x);
			}
		}
	}
`;

export default InformativeSliderStyle;
